// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xXZri","social":"Footer_social__jyMbW"};